import { createListFromObject } from "../../Utilities/Types/listUtilities";

export const REPORT_TYPES = {
    UserManagement: "patrons",
    Students: "students",
    Orders: "orders",
    LoanHistory: "loan-library",
    OrdersCompleted: "orders-completed"
};

export const REPORT_TYPES_LIST = createListFromObject(REPORT_TYPES);